<template>
  <div class="relative">
    <menu-item label="页头入口" bottom-tip="也可在支持跳转的菜单中添加入口">
      <menu-switch v-model="model.iconEnabled" target-key="iconEnabled" margin-bottom="0" label="开启" />
    </menu-item>
    <menu-item label="ICON">
      <menu-background-image :target="model.icon" target-key="icon" />
    </menu-item>
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" target-key="textColor" />
    </menu-item>
    <menu-item label="执行按钮文字色">
      <menu-fill :target="model.submitColor" target-key="submitColor" />
    </menu-item>
    <menu-item label="执行按钮填充色">
      <menu-fill :target="model.submitBackground" target-key="submitBackground" />
    </menu-item>
    <menu-item label="领取按钮文字色">
      <menu-fill :target="model.getColor" target-key="getColor" />
    </menu-item>
    <menu-item label="领取按钮填充色">
      <menu-fill :target="model.getBackground" target-key="getBackground" />
    </menu-item>
    <menu-item label="已完成按钮文字色">
      <menu-fill :target="model.doneColor" target-key="doneColor" />
    </menu-item>
    <menu-item label="已完成按钮填充色">
      <menu-fill :target="model.doneBackground" target-key="doneBackground" />
    </menu-item>
    <menu-item label="任务行背景色">
      <menu-fill :target="model.rowBackground" target-key="rowBackground" />
    </menu-item>
  </div>
</template>

<script>
import MenuItem from '~/components/menu/menuItem.vue'
import MenuSwitch from '~/components/menu/menuSwitch.vue'
import MenuFill from '~/components/menu/menuFill.vue'
import MenuBackgroundImage from '~/components/menu/menuBackgroundImage.vue'

export default {
  name: 'MissionCenterSettingEdit',
  components: { MenuBackgroundImage, MenuFill, MenuSwitch, MenuItem },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  }
}
</script>


<style lang="less">

</style>
